/**
 * Ryan O'Dowd
 * 2024-11-21
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      alignSelf: 'center',
      textAlign: 'center',
      paddingHorizontal: 0,
      flex: 1,
      width: '100%',
      fontSize: globalScale * 20,
      borderColor: colors.primary,
      borderBottomWidth: globalScale * 2,
    },
    contentStyle: {
      width: '100%', // required on web, otherwise the 4th radio button isn't clickable, despite the textinput being an appropriate width
    },
  };
};

export default getStyles;
